"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _logo_Agam = _interopRequireDefault(require("../asset/logos/logo_Agam.svg"));
require("../asset/css/header.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Header(props) {
  let {
    titre,
    sousTitre
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: "header__container",
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: "logo__agam",
    xl: 2,
    lg: 2,
    md: 2,
    sm: 2,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logo_Agam.default,
    alt: "logo agam"
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: "titre",
    xl: 4,
    lg: 4,
    md: 4,
    sm: 5,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement("h1", null, titre), /*#__PURE__*/_react.default.createElement("h2", null, sousTitre)), props.children);
}
var _default = Header;
exports.default = _default;